import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

class MessageStore extends ReduceStore {
    getInitialState() {
        return [];
    }

    getLastMessage() {
        return this.getState();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.COURSE_ENROLMENT_BY_FILTER_SAVE_SUCCESS:
                return ((!!action.data.backgroundTask) ? 'Request Successful. Users will shortly be assigned to this course.' : state);

            case ActionTypes.COURSE_ENROLMENT_BULK_UPDATE_SUCCESS:
                return ((!!action.data.backgroundTask) ? 'Request Successful. Enrolments status will shortly be updated.' : state);

            case ActionTypes.COURSE_ENROLMENT_BULK_DELETE_SUCCESS:
                return ((!!action.data.backgroundTask) ? 'Request Successful. Enrolments will shortly be deleted from this course.' : state);

            case ActionTypes.COURSE_ENROLMENT_CHECK_COMPLETE_SUCCESS:
                return 'Course completed successfully';

            case ActionTypes.COURSE_ENROLMENT_CHECK_COMPLETE_FAILURE:
                return action.data;

            case ActionTypes.COURSE_ENROLMENT_EMAIL_SEND_SUCCESS:
                return `${action.data} enrolment emails successfully sent`;

            case ActionTypes.REPORT_EMAIL_SUCCESS:
                return 'Email successfully sent';

            case ActionTypes.MESSAGE_REMOVE:
                return '';

            default:
                return state;
        }
    }
}

export default new MessageStore(CentricDispatcher);
